import { createContext, useContext, useEffect, useState } from "react";
import { fetchData } from "../../lib/dashboard/data";
import useSWR from "swr";
import { updateData } from "../../lib/dashboard/actions";
import { useSearchParams } from "react-router-dom";

const RecommendedContext = createContext();

const RecommendedProvider = ({ children }) => {
  const [configData, setConfigData] = useState({
    configList: [],
    defaultConfig: {
      foundamental: [],
      marketwatch: [],
    },
  });
  const [selectedConfigName, setSelectedConfigName] = useState("");
  const [currentConfig, setCurrentConfig] = useState({
    id: null,
    is_default: null,
    name: "",
  });
  const [configNewName, setConfigNewName] = useState("");
  const [editedName, setEditedName] = useState("");
  const [isLoading, setIsLoading] = useState({
    addNewNameLoading: false,
  });

  const [searchParams] = useSearchParams();

  //GET TABLE DATA
  const tableData = useSWR(
    [`/stock-market/recommended`, searchParams.toString()],
    ([url, params]) => fetchData(url, params),
    { dedupingInterval: 60000 }
  );

    //GET SETTING NAMES WITH DEFAULT TRUE DATA
    const config = useSWR(
        "/stock-market/v2/recomm-config",
        fetchData,
        {revalidateOnFocus: false}
    )

  //SET CONFIG DATA INTO STATE
  useEffect(() => {
    if (config.data) {
      setConfigData({
        configList: config?.data?.config_list,
        defaultConfig: config?.data?.default_config,
      });
    }
  }, [config.data]);

  // GET IS_DEFAULT = TRUE OBJECT
  useEffect(() => {
    if (configData?.configList) {
      const defaultConfig = configData.configList.find(
        (item) => item.is_default === true
      );
      if (defaultConfig) {
        setCurrentConfig(defaultConfig);
      }
    }
  }, [configData.configList]);

  //UPDATE THE CONFIG
  const updateConfig = async (body) => {
    await updateData(body, `/stock-market/v2/recomm-config`, "PATCH");
  };

  return (
    <RecommendedContext.Provider
      value={{
        isLoading,
        setIsLoading,
        tableData,
        config,
        configData,
        setConfigData,
        currentConfig,
        setCurrentConfig,
        selectedConfigName,
        setSelectedConfigName,
        configNewName,
        setConfigNewName,
        editedName,
        setEditedName,
        updateConfig,
      }}
    >
      {children}
    </RecommendedContext.Provider>
  );
};

export default RecommendedProvider;

export function useRecommendedContext() {
  return useContext(RecommendedContext);
}
